import React, {useEffect, useState} from 'react';
import {IconField} from "primereact/iconfield";
import {InputIcon} from "primereact/inputicon";
import {InputText} from "primereact/inputtext";
import {useTranslate} from "../../../system/useTranslate";
import {useSelector} from "react-redux";
import {DataView} from "primereact/dataview";
import Avatar from "../../../system/components/avatar";
import {Button} from "primereact/button";
import {Checkbox} from "primereact/checkbox";
import DatatableEmptyMessage from "../../../system/components/datatable-empty-message";

const entityKeys = (entity) => [entity?.documentId, entity?.id]
    .filter((value) => value !== null && value !== undefined)
    .map(String);
const sameEntity = (left, right) => entityKeys(left).some((key) => entityKeys(right).includes(key));
const sameMembership = (left, right) => (
    sameEntity(left, right)
    || sameEntity(left?.member, right?.member)
);

function MultiSelectMembers({
    value,
    options,
    onCancel,
    onConfirm,
    onChange,
    filter=(e)=>true,
    disabled=(e)=>false,
}) {
    const {workspaceMembershipData} = useSelector((state) => state.app);
    const [searchText, setSearchText] = useState("");
    const translate = useTranslate();
    const [selectedMembers, setSelectedMembers] = useState([])
    const availableMembers = Array.isArray(options)
        ? options
        : workspaceMembershipData?.workspace?.workspace_memberships || [];

    useEffect(()=>{
        setSelectedMembers(Array.isArray(value) ? value : []);
    }, [value])

    const updateSelectedMembers = (member)=>{

        let _selectedMembers = [...selectedMembers];
        if (_selectedMembers.find((selectedMember) => sameMembership(selectedMember, member))){
            _selectedMembers = _selectedMembers.filter((selectedMember) => !sameMembership(selectedMember, member));
            onChange?.({member, status:'removed'});
        }
        else{
            _selectedMembers = [...selectedMembers, member];
            onChange?.({member, status:'added'});
        }
        setSelectedMembers(_selectedMembers);

    }

    const ItemTemplate = (data)=>{
        const itemDisabled = disabled(data);
        return(
            <div className="w-full flex align-items-center justify-content-between py-1 text-xs">
               <div className="flex gap-2 align-items-center">
                   <Avatar memberData={data?.member}/>
                   <span>{data?.member.fullname}</span>
               </div>
                <Checkbox
                    aria-label={data?.member?.fullname}
                    checked={!!selectedMembers?.find((selectedMember) => sameMembership(selectedMember, data))}
                    disabled={itemDisabled}
                    onChange={()=>{updateSelectedMembers(data)}}
                />
            </div>
        )
    }

    return (
        <div className="w-14rem flex flex-column p-2 gap-2">
            <div className="border-bottom-1 border-100">
                <IconField dir="rtl">
                    <InputIcon className="pi pi-search"/>
                    <InputText className="w-full text-xs py-2" placeholder={translate("search-members-placeholder")} value={searchText} onChange={(e)=>{setSearchText(e.target.value)}}/>
                </IconField>
            </div>
            <DataView emptyMessage={<DatatableEmptyMessage/>} layout="list" itemTemplate={ItemTemplate} value={availableMembers.filter(filter).filter(e=>e.member?.fullname?.includes(searchText))}/>
            {(onCancel||onConfirm)&&(
                <div className="flex align-items-center justify-content-between">
                    {onCancel&&<Button onClick={()=>{onCancel?.()}} label={translate("cancel")} className="p-2 text-xs shadow-none border-none p-button-text"/>}
                    {onConfirm&&<Button onClick={()=>{onConfirm?.(selectedMembers)}} label={translate("confirm-add")} className="p-2 text-xs shadow-none border-none"/>}
                </div>
            )}
        </div>
    );
}

export default MultiSelectMembers;
